import { render, staticRenderFns } from "./CartProduct.vue?vue&type=template&id=3831eed4"
import script from "./CartProduct.vue?vue&type=script&lang=js"
export * from "./CartProduct.vue?vue&type=script&lang=js"
import style0 from "./CartProduct.vue?vue&type=style&index=0&id=3831eed4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports